import { Component, OnInit } from '@angular/core';
import { Routes } from '@angular/router';

@Component({
  selector: 'app-localization',
  template: `<router-outlet>
      
  </router-outlet>`
})
export class LocalizationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/localization/localization.component.ts